import * as Api from './service'
import { USER_STATUS, IHomeData, TASK_STATUS } from '../consts'
const DefaultHomeData: IHomeData = {
  // 近7日分数记录的第一条记录
  pointListOne: '',
  // 状态变更的第一条记录
  statusChangeListOne:
    '2020/06.03 您由【xx】状态变更为【xx】状态，服务质量分变更为x分',
  /* ===通过字段=== */
  // 更新时间
  updateTime: '',

  /* ===未通过字段=== */
  // 整改次数
  improvementNum: 0,

  // 任务1的状态 1 完成 0 未完成
  task1Status: TASK_STATUS.unfinished,

  // 任务2的闭关时间（小时）
  task2RuleTime: '',

  // 任务2的服务器当前时间
  task2ServerCurrTime: 0,
  // 任务2的服务器到期时间
  task2ServerExpireTime: 0,

  // 任务2的状态 1 完成 0 未完成
  task2Status: TASK_STATUS.unfinished
}
export default {
  namespace: 'serviceScoreHome',
  state: {
    loadingVisible: true,
    // 统计日期
    statDate: '',
    point: 0,
    taskList: [],
    homeData: { ...DefaultHomeData },
    userStatus: USER_STATUS.stopCount
  },
  effects: {
    * querySqpMainPage ({ payload }, { call, put }) {
      const {
        data: {
          data: { taskList, abnormal, normal, userStatus, point, statDate }
        }
      } = yield call(Api.querySqpMainPage, payload)
      yield put({
        type: 'save',
        payload: {
          loadingVisible: false,
          taskList: abnormal.taskList,
          homeData: userStatus === USER_STATUS.normal ? normal : abnormal,
          userStatus,
          point,
          statDate
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
